import Market from './Market';

export default Market;



// WEBPACK FOOTER //
// ./src/components/Market/index.tsx